// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/css/app.css
// module id = 301
// module chunks = 0